(function () {
  var MORROW_VARIANT_ID = 48930864103481;
  var PAID_GIFT_VARIANT_ID = 50566030164025;
  var FREE_GIFT_VARIANT_ID = 50566222020665;
  var FREE_WARRANTY_VARIANT_ID = 50566221987897;

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function request(path, body) {
    return fetch(shopRoot() + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: body
        ? { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        : { 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status || data.errors) {
          throw new Error(data.description || data.message || data.errors || 'Cart update failed.');
        }
        return data;
      });
    });
  }

  function announceCartUpdate(cart, source) {
    var event = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    event.action = 'update';
    event.context = 'cart';
    event.promise = Promise.resolve({
      cart: { totalQuantity: cart.item_count },
      detail: {
        sections: cart.sections || {},
        items: cart.items || [],
        itemCount: cart.item_count,
        source: source || 'morrow-cart-bundle',
        didError: false
      }
    });
    document.dispatchEvent(event);
    document.dispatchEvent(new CustomEvent('morrow:cart:update', { bubbles: true, detail: cart }));
  }

  function bundleProperties(quantity, deal) {
    if (quantity < 2) return null;
    var props = { '_morrow_bundle': deal };
    if (quantity >= 5) props['_morrow_mystery_reward'] = 'free';
    return props;
  }

  function setBundleQuantity(lineKey, variantId, quantity, deal) {
    var sections = 'cart-drawer-section';
    var sectionsUrl = window.location.pathname;
    var properties = bundleProperties(quantity, deal);

    // Shopify cannot clear every line-item property with an empty object. Re-add
    // the one-kit line cleanly so an old bundle/reward property never survives.
    if (quantity === 1) {
      return request('cart/change.js', { id: lineKey, quantity: 0 })
        .then(function () {
          return request('cart/add.js', {
            items: [{ id: variantId || MORROW_VARIANT_ID, quantity: 1 }],
            sections: sections,
            sections_url: sectionsUrl
          });
        })
        .then(function (added) {
          return request('cart.js').then(function (cart) {
            cart.sections = added.sections || {};
            return cart;
          });
        });
    }

    return request('cart/change.js', {
      id: lineKey,
      quantity: quantity,
      properties: properties,
      sections: sections,
      sections_url: sectionsUrl
    });
  }

  function syncBundleFreebies(quantity) {
    var sections = 'cart-drawer-section';
    var sectionsUrl = window.location.pathname;
    var lastSections = {};

    return request('cart.js').then(function (cart) {
      var items = cart.items || [];
      var warranty = items.find(function (item) { return parseInt(item.variant_id, 10) === FREE_WARRANTY_VARIANT_ID; });
      var freeGift = items.find(function (item) { return parseInt(item.variant_id, 10) === FREE_GIFT_VARIANT_ID; });
      var paidGift = items.find(function (item) { return parseInt(item.variant_id, 10) === PAID_GIFT_VARIANT_ID; });
      var chain = Promise.resolve();

      function change(key, qty) {
        chain = chain.then(function () {
          return request('cart/change.js', {
            id: key,
            quantity: qty,
            sections: sections,
            sections_url: sectionsUrl
          }).then(function (data) {
            lastSections = data.sections || lastSections;
          });
        });
      }

      function add(id, label) {
        chain = chain.then(function () {
          return request('cart/add.js', {
            items: [{
              id: id,
              quantity: 1,
              properties: { '_morrow_bundle_freebie': label }
            }],
            sections: sections,
            sections_url: sectionsUrl
          }).then(function (data) {
            lastSections = data.sections || lastSections;
          });
        });
      }

      if (quantity >= 3 && !warranty) add(FREE_WARRANTY_VARIANT_ID, '30-day warranty');
      if (quantity < 3 && warranty) change(warranty.key, 0);

      if (quantity >= 5 && !freeGift) add(FREE_GIFT_VARIANT_ID, 'mystery gift');
      if (quantity < 5 && freeGift) change(freeGift.key, 0);

      if (quantity >= 5 && paidGift) change(paidGift.key, 0);

      return chain.then(function () {
        return request('cart.js').then(function (fresh) {
          fresh.sections = lastSections;
          return fresh;
        });
      });
    });
  }


  function initMorrowCartEnhancements() {
    var timer = document.querySelector('[data-morrow-cart-timer]');
    if (timer) {
      var value = timer.querySelector('[data-morrow-cart-timer-value]');
      var minutes = Math.max(1, parseInt(timer.dataset.minutes || '10', 10));
      var key = 'morrowCartReserveUntil';
      var now = Date.now();
      var end = 0;
      try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) {}
      if (!end || end <= now) {
        end = now + minutes * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
      if (window.__morrowCartReserveInterval) window.clearInterval(window.__morrowCartReserveInterval);
      function tick() {
        var remain = Math.max(0, end - Date.now());
        var total = Math.ceil(remain / 1000);
        if (value) value.textContent = String(Math.floor(total / 60)).padStart(2,'0') + ':' + String(total % 60).padStart(2,'0');
        if (remain <= 0 && window.__morrowCartReserveInterval) {
          window.clearInterval(window.__morrowCartReserveInterval);
          window.__morrowCartReserveInterval = null;
        }
      }
      tick();
      window.__morrowCartReserveInterval = window.setInterval(tick, 1000);
    }
  }

  function scrollMorrowAddons(direction) {
    var track = document.querySelector('[data-morrow-addon-track]');
    if (!track) return;
    var card = track.querySelector('.morrow-drawer-addon');
    var amount = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * .85;
    track.scrollBy({left:direction * amount,behavior:'smooth'});
  }

  function updateButtonState(button, status) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';
  }

  function restoreButtonState(button, label, status, error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (label) button.textContent = label;
    if (status) status.textContent = error.message || 'We could not update the bundle. Please try again.';
  }

  function tidyMorrowCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var productLink = drawer.querySelector('a[href*="/products/washable-pet-hair-roller-duo"]');
    if (!productLink) return;
    var row = productLink.closest('.cart-items__table-row');
    if (!row) return;

    row.classList.remove('morrow-native-quantity-hidden');
    row.classList.add('morrow-product-row');

    var input = row.querySelector('.quantity-selector input[type="number"]');
    if (input) {
      input.readOnly = true;
      input.setAttribute('inputmode','none');
    }

    var quantity = input ? parseInt(input.value || '1',10) : 1;
    var minus = row.querySelector('.quantity-minus');
    var plus = row.querySelector('.quantity-plus');
    if (minus) minus.disabled = quantity <= 1;
    if (plus) plus.disabled = quantity >= 5;
  }

  function scheduleMorrowCartTidy() {
    window.setTimeout(function(){ tidyMorrowCartDrawer(); initMorrowCartEnhancements(); }, 60);
    window.setTimeout(function(){ tidyMorrowCartDrawer(); initMorrowCartEnhancements(); }, 220);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleMorrowCartTidy);
  else scheduleMorrowCartTidy();
  document.addEventListener('shopify:cart:lines-update', scheduleMorrowCartTidy);
  document.addEventListener('morrow:cart:update', scheduleMorrowCartTidy);

  function morrowTierFromNativeStep(current, direction) {
    var tiers = [1,2,3,5];
    var i = tiers.indexOf(current);
    if (i < 0) {
      if (current <= 1) i = 0;
      else if (current <= 2) i = 1;
      else if (current <= 3) i = 2;
      else i = 3;
    }
    var nextIndex = Math.max(0, Math.min(tiers.length - 1, i + direction));
    return tiers[nextIndex];
  }

  function morrowDealForQuantity(quantity) {
    if (quantity === 2) return '2-kit-15';
    if (quantity === 3) return '3-kit-25';
    if (quantity === 5) return 'buy-4-get-1-free';
    return '';
  }

  document.addEventListener('click', function (event) {
    var stepButton = event.target.closest('#cart-drawer .morrow-product-row .quantity-minus, #cart-drawer .morrow-product-row .quantity-plus');
    if (!stepButton) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var row = stepButton.closest('.morrow-product-row');
    var input = row && row.querySelector('.quantity-selector input[type="number"]');
    var selector = row && row.querySelector('.quantity-selector');
    if (!row || !input || !selector || stepButton.disabled) return;

    var current = parseInt(input.value || '1',10);
    var direction = stepButton.classList.contains('quantity-plus') ? 1 : -1;
    var target = morrowTierFromNativeStep(current, direction);
    if (target === current) return;

    var lineKey = row.dataset.key;
    var variantId = parseInt(selector.dataset.variantId || MORROW_VARIANT_ID,10);
    var deal = morrowDealForQuantity(target);

    stepButton.disabled = true;
    setBundleQuantity(lineKey, variantId, target, deal)
      .then(function () { return syncBundleFreebies(target); })
      .then(function (cart) { announceCartUpdate(cart, 'morrow-native-quantity'); })
      .catch(function () { stepButton.disabled = false; });
  }, true);

  document.addEventListener('click', function (event) {
    var nav = event.target.closest('[data-morrow-addon-prev], [data-morrow-addon-next]');
    if (!nav) return;
    event.preventDefault();
    scrollMorrowAddons(nav.hasAttribute('data-morrow-addon-prev') ? -1 : 1);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-morrow-cart-upgrade], [data-morrow-cart-adjust], [data-morrow-add-variant]');
    if (!button || button.disabled) return;

    if (button.hasAttribute('data-morrow-add-variant')) {
      var addVariantId = parseInt(button.dataset.morrowAddVariant || button.getAttribute('data-morrow-add-variant'), 10);
      var addStatus = document.querySelector('[data-morrow-addon-status]');
      var originalLabel = button.textContent;
      if (!addVariantId) return;
      updateButtonState(button, addStatus);
      button.textContent = 'Adding…';
      var sections = 'cart-drawer-section';
      var sectionsUrl = window.location.pathname;
      request('cart/add.js', {
        items: [{ id: addVariantId, quantity: 1 }],
        sections: sections,
        sections_url: sectionsUrl
      }).then(function (added) {
        return request('cart.js').then(function (cart) {
          cart.sections = added.sections || {};
          return cart;
        });
      }).then(function (cart) {
        announceCartUpdate(cart, 'morrow-cart-addon');
      }).catch(function (error) {
        restoreButtonState(button, originalLabel, addStatus, error);
      });
      return;
    }

    var lineKey = button.dataset.lineKey;
    var variantId = parseInt(button.dataset.variantId || MORROW_VARIANT_ID, 10);
    var quantity = parseInt(button.dataset.quantity || '0', 10);
    var deal = button.dataset.deal || '';
    var isUpgrade = button.hasAttribute('data-morrow-cart-upgrade');
    var wrapper = button.closest(isUpgrade ? '.morrow-drawer-upgrade' : '.morrow-drawer-quantity');
    var status = wrapper && wrapper.querySelector(isUpgrade
      ? '[data-morrow-cart-upgrade-status]'
      : '[data-morrow-cart-adjust-status]');
    var label = isUpgrade ? button.textContent : '';

    if (!lineKey || quantity < 1 || quantity > 5 || (quantity > 1 && !deal)) return;

    updateButtonState(button, status);
    if (isUpgrade) button.textContent = 'Updating…';

    setBundleQuantity(lineKey, variantId, quantity, deal)
      .then(function () {
        return syncBundleFreebies(quantity);
      })
      .then(function (cart) {
        announceCartUpdate(cart, isUpgrade ? 'morrow-cart-upgrade' : 'morrow-cart-quantity');
      })
      .catch(function (error) {
        restoreButtonState(button, label || null, status, error);
      });
  });
})();
